import { InvoiceStatus, InvoiceType } from "../../../types/types";

export const getStatusId = (status: InvoiceStatus) => {
    switch(status) {
    case InvoiceStatus.PREVISIONNELLE:
        return 0;
    case InvoiceStatus.A_EDITER:
        return 50;
    case InvoiceStatus.A_VALIDER:
        return 100;
    case InvoiceStatus.A_EMETTRE:
        return 200;
    case InvoiceStatus.EMISE:
        return 300;
    case InvoiceStatus.PARTIELLEMENT_RECOUVREE:
        return 400;
    case InvoiceStatus.RECOUVREE:
        return 500;
    case InvoiceStatus.ANNULEE:
        return 600;
    }
}
export const getStatusFromId = (status: number) => {
    switch(status) {
    case 0:
        return InvoiceStatus.PREVISIONNELLE;
    case 50:
        return InvoiceStatus.A_EDITER;
    case 100:
        return InvoiceStatus.A_VALIDER;
    case 200:
        return InvoiceStatus.A_EMETTRE;
    case 300:
        return InvoiceStatus.EMISE;
    case 400:
        return InvoiceStatus.PARTIELLEMENT_RECOUVREE;
    case 500:
        return InvoiceStatus.RECOUVREE;
    case 600:
        return InvoiceStatus.ANNULEE;
    }
}

export const getTypeId = (type: InvoiceType) => {
    switch(type) {
    case InvoiceType.HONORAIRES_ET_FRAIS:
        return 1;
    case InvoiceType.HONORAIRES:
        return 2;
    case InvoiceType.FRAIS:
        return 3;
    }
}
export const getTypeFromId = (typeId: number) => {
    switch(typeId) {
    case 1:
        return InvoiceType.HONORAIRES_ET_FRAIS;
    case 2:
        return InvoiceType.HONORAIRES;
    case 3:
        return InvoiceType.FRAIS;
    }
}
